function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.8186 27.1015L27.0822 24.3698C26.9454 24.2605 26.7812 24.1785 26.617 24.1785H26.1792C26.918 23.2224 27.3832 22.0205 27.3832 20.682C27.3832 17.5678 24.8111 15 21.6916 15C18.5448 15 16 17.5678 16 20.682C16 23.8234 18.5448 26.3639 21.6916 26.3639C23.0051 26.3639 24.2091 25.9268 25.1941 25.162V25.6263C25.1941 25.7902 25.2489 25.9541 25.3857 26.0907L28.0947 28.7951C28.3683 29.0683 28.7788 29.0683 29.025 28.7951L29.7912 28.0302C30.0649 27.7844 30.0649 27.3746 29.8186 27.1015ZM21.6916 24.1785C19.7488 24.1785 18.1891 22.6215 18.1891 20.682C18.1891 18.7698 19.7488 17.1854 21.6916 17.1854C23.6071 17.1854 25.1941 18.7698 25.1941 20.682C25.1941 22.6215 23.6071 24.1785 21.6916 24.1785Z",
  fill: "#D5D7DE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 11.1429V6H10.7143V8H7V11.1429H5ZM19.2857 6V8H23V11.1429H25V6H19.2857ZM10.7143 24V22H7V18.8571H5V24H10.7143Z",
  fill: "#D5D7DE"
});

var SvgZoomIn = function SvgZoomIn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZoomIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoomIn.9f4e66c6.svg";
export { ForwardRef as ReactComponent };